import React from "react";
import { ExamType, ExamTemplateWithStructureIndex } from "../../../model/Exam";
import { ExamDayViewModel } from "../../../model/ExamDayViewModel";
import { ExamSessionViewModel } from "../../../model/ExamSessionViewModel";
import { LocationViewModel } from "../../../model/LocationViewModel";
import { RoomViewModel } from "../../../model/RoomViewModel";
import { TimeSlot, TimeSlotStructure } from "../../../model/TimeSlotStructure";

export interface SchedulerContext {
  examTypes: ExamType[];
  readonly: boolean;
  examSession: ExamSessionViewModel | undefined;
  examSessionLabel: string;
  selectedLocationName: string;
  isSessionPublished: boolean;
  selectedExamDayId: string;
  locations: LocationViewModel[];
  examDays: ExamDayViewModel[];
  rooms: RoomViewModel[];
  exams: ExamTemplateWithStructureIndex[];
  timeSlotStructure: TimeSlotStructure;
  addTimeSlotExam: (roomId: string, examId: string, timeSlotIndex: number) => void;
  removeTimeSlotExam: (roomId: string, examId: string, timeSlotIndex: number) => void;
  clearTimeSlotExams: (roomId: string, timeSlotIndex: number) => void;
  setAllTimeSlotsExams: (roomId: string, examIds: string[]) => void;
  changeSelectedExamDay: (examDayId: string) => void;
  save: () => void;
  navigateToSession: () => void;
  renderCell?: (examIds: string[], room: RoomViewModel, timeSlotIndex: number, key?: string) => JSX.Element | null;
  renderTimeSlotLabel?: (timeSlot: TimeSlot) => JSX.Element | null;
}

export const initialSchedulerContextValue: SchedulerContext = {
  examTypes: [],
  readonly: false,
  examSession: {} as ExamSessionViewModel,
  examSessionLabel: "",
  selectedLocationName: "",
  isSessionPublished: false,
  selectedExamDayId: "",
  locations: [],
  examDays: [],
  rooms: [],
  exams: [],
  timeSlotStructure: {} as TimeSlotStructure,
  addTimeSlotExam: (roomId: string, examId: string, timeSlotIndex: number) => {},
  removeTimeSlotExam: (roomId: string, examId: string, timeSlotIndex: number) => {},
  clearTimeSlotExams: (roomId: string, timeSlotIndex: number) => {},
  setAllTimeSlotsExams: (roomId: string, examIds: string[]) => {},
  changeSelectedExamDay: (examDayId: string) => {},
  save: () => {},
  navigateToSession: () => {},
};

export const SchedulerContextValue = React.createContext<SchedulerContext>(initialSchedulerContextValue);
